import { lazy } from "lazy-var";
import { ref, type Ref } from "vue";
import { type MsgFromWorker, type MsgToWorker } from "./type";

const lazyGetFollowedProducts = lazy(() => {
    const worker = new Worker(new URL("./worker.ts", import.meta.url));
    worker.onmessage = (event) => {
        const data = event.data as MsgFromWorker;
        result.value.push(...data);
    };
    worker.postMessage("fetchFollowedProductIds" as MsgToWorker);
    const result = ref<number[]>([]);
    return result;
});

export function getFollowedProductIds() {
    return lazyGetFollowedProducts.get() as Ref<number[]>;
}
